(function () {
	'use strict';

	angular
		.module('franchiser.components')
		.controller('ApplicationsFranchiserFormController', ApplicationsFranchiserFormController)

	/** @ngInject */
	function ApplicationsFranchiserFormController($filter, $state, $q, $stateParams, HttpService, LoadingHelper, ApplicationService,
		FlowConfigurationHelper, UtilHelper, PermissionGroupService, ModuleService, sweetAlert, ApplicationSharedDataService, ImagePathHelper) {
		const vm = this;

		vm.flowFileFinishedMain = ($file, $message) => {
			var message = angular.fromJson($message);

			vm.applicationData.Image = message.FileSaveName;
			vm.imageMain.display = ImagePathHelper.imageHandlerPath('application', vm.applicationData.Id, message.FileSaveName);

			vm.saveApplication();
		}

		vm.flowFilesAddedMain = ($file) => {
			let whiteList = ['png', 'gif', 'jpg', 'jpeg'];
			let extension = $file.getExtension();

			if (!whiteList.includes(extension)) {
				UtilHelper.setErrorMessageForm('.image-block', 'Formato inválido.', true);
				return false;
			}

			vm.oldFormImageMain = vm.applicationData.Image;

			LoadingHelper.startLoading('.image-loading-holder');

			UtilHelper.removeErrorMessageForm('.image-block');
		}

		vm.deleteImageMain = () => {
			HttpService
				.delete('/files/delete/application/' + vm.applicationData.Id + '/' + vm.applicationData.Image)
				.then(() => {
					vm.applicationData.Image = '';
					vm.imageMain.display = '';

					if (vm.flowScopeMain.flow.files.length)
						vm.flowScopeMain.flow.files[0].cancel();

					vm.saveApplication();
				},
					error => errorCallback(error)
				);
		}

		vm.generateRandomHash = fromId => {
			LoadingHelper.startLoading('.page-content');

			ApplicationService
				.generateRandomHash()
				.then(success => {
					if (fromId == 1)
						vm.applicationData.ClientId = success;
					else
						vm.applicationData.ClientSecret = success;

					vm.saveApplication(false);
				})
		}

		vm.changeTab = tabId => {
			vm.selectedTab = tabId;
		}

		vm.changeApplicationStatus = status => {
			vm.applicationData.Active = status;
		}

		vm.onChangePermissionGroups = (isSelectAll = false) => {
			if (isSelectAll) {
				if (vm.selectAllPermissionGroups)
					vm.selectedPermissionGroups = vm.permissionGroups.map(permissionGroup => permissionGroup);
				else
					vm.selectedPermissionGroups = [];
			}

			if (vm.selectedPermissionGroups.length == vm.permissionGroups.length)
				vm.selectAllPermissionGroups = true;
			else
				vm.selectAllPermissionGroups = false;
		}

		vm.saveApplication = (showLoading = true) => {
			if (showLoading)
				LoadingHelper.startLoading('.loading-holder');

			let applicationData = angular.copy(vm.applicationData);
			let permissionData = vm.permissions ? vm.permissions.filter(x => x.IsView) : [];

			applicationData.PermissionGroup_Application = [];
			applicationData.Application_Module = permissionData;

			if (vm.selectedPermissionGroups.length) {
				applicationData.PermissionGroup_Application = vm.selectedPermissionGroups.reduce((acc, cur) => {
					acc.push({
						ApplicationId: applicationData.Id,
						PermissionGroupId: cur.Id
					})

					return acc;
				}, []);
			}

			if (!applicationData.Id) {
				applicationData.Image = '';

				ApplicationService
					.post(applicationData)
					.then(success => successCallback(success, true), errorCallback);
			} else {
				ApplicationService
					.put(applicationData)
					.then(successCallback, errorCallback);
			}
		}

		vm.deleteApplication = () => {
			sweetAlert.swal({
				title: 'Você tem certeza?',
				text: 'Essa aplicação não conseguirá mais acessar o sistema! Não é possível desfazer essa ação!',
				type: 'warning',
				confirmButtonText: 'Sim, tenho certeza',
				showCancelButton: true,
				cancelButtonText: 'Não, cancelar',
				allowOutsideClick: false,
				allowEscapeKey: false
			}).then(response => {
				if (response.value) {
					LoadingHelper.startLoading('.page-content');

					ApplicationService
						.deleteData(vm.applicationData.Id)
						.then(() => {
							$state.go('app.franchiser-applications-list');
							UtilHelper.successCallback('delete');
							LoadingHelper.stopLoading('.page-content');
						}, error => {
							LoadingHelper.stopLoading('.page-content');
							UtilHelper.errorCallback(error);
						})
				}
			})
		}

		vm.saveApplicationSharedData = () => {
			LoadingHelper.startLoading('.loading-holder');

			let applicationSharedData = angular.copy(vm.applicationSharedData);

			if (applicationSharedData.length) {
				applicationSharedData.map(applicationSD => {
					if (applicationSD.PostUrl[0] != '/')
						applicationSD.PostUrl = `/${applicationSD.PostUrl}`;

					if (applicationSD.PutUrl[0] != '/')
						applicationSD.PutUrl = `/${applicationSD.PutUrl}`;

					if (applicationSD.DeleteUrl[0] != '/')
						applicationSD.DeleteUrl = `/${applicationSD.DeleteUrl}`;

					applicationSD.Token = vm.applicationSharedData.Token;
					applicationSD.ApplicationId = vm.applicationData.Id;
				});
			}

			ApplicationSharedDataService
				.updateMultiple(applicationSharedData)
				.then(success => {
					vm.applicationSharedData = handleApplicationSharedData(success);
					vm.applicationSharedData.Token = vm.applicationSharedData[0].Token;

					UtilHelper.successCallback('update');
					LoadingHelper.stopLoading('.loading-holder');
				}, errorCallback);
		}

		vm.onCheckAll = () => {
			for (let index = 0; index < vm.permissions.length; index++) {
				const permission = vm.permissions[index];

				permission.IsView = vm.getAll;
				permission.IsEdit = vm.getAll;
			}
		}

		init();

		function successCallback(success, isPost) {
			if (isPost) {
				vm.applicationData = success;

				$state.go('app.franchiser-applications-edit', {
					applicationId: vm.applicationData.Id
				}, {
					notify: false
				});

				UtilHelper.successCallback('create');
			} else {
				UtilHelper.successCallback('update');
			}

			LoadingHelper.stopLoading('.loading-holder');
		}

		function errorCallback(error) {
			LoadingHelper.stopLoading('.loading-holder');
			UtilHelper.errorCallback(error);
		}

		function getApplication() {
			const applicationId = $stateParams.applicationId;

			if (!applicationId) {
				LoadingHelper.stopLoading('.loading-holder');
				return;
			}

			ApplicationService
				.get(applicationId)
				.then(success => {
					success.FormattedRegistrationDate = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');

					vm.applicationData = success;
					vm.selectAllPermissionGroups = vm.applicationData.PermissionGroup_Application.length == vm.permissionGroups.length;

					if (vm.applicationData.Image)
						vm.imageMain.display = ImagePathHelper.imageHandlerPath('application', vm.applicationData.Id, vm.applicationData.Image);

					if (vm.applicationData.PermissionGroup_Application && vm.applicationData.PermissionGroup_Application.length) {
						vm.selectedPermissionGroups = vm.permissionGroups.filter(acc => {
							if (vm.applicationData.PermissionGroup_Application.find(commAcc => commAcc.PermissionGroupId == acc.Id)) {
								return acc;
							}
						});
					}

					let permissions = [];

					if (vm.applicationData.Application_Module) {
						permissions = vm.applicationData.Application_Module;

						for (let index = 0; index < vm.modules.length; index++) {
							const module = vm.modules[index];
							const permission = permissions.find(x => x.ModuleId == module.Id);

							if (!permission) {
								permissions.push({
									ApplicationId: vm.applicationData.Id,
									IsView: null,
									IsEdit: null,
									Module: module,
									ModuleId: module.Id
								})
							} else {
								permission.IsView = true;
							}
						}
					}

					vm.permissions = $filter('orderBy')(permissions, 'Module.Title', false);

					getApplicationSharedData(applicationId);
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.loading-holder');
				})
		}

		function getApplicationSharedData(applicationId) {
			ApplicationSharedDataService
				.getByParameters({ ApplicationId: applicationId })
				.then(success => {
					const applicationSharedData = success.Registers;

					vm.applicationSharedData = handleApplicationSharedData(applicationSharedData);
					vm.applicationSharedData.Token = vm.applicationSharedData.length ? vm.applicationSharedData[0].Token : '';

					LoadingHelper.stopLoading('.loading-holder');
				}, error => {
					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.loading-holder');
				})
		}

		function handleApplicationSharedData(applicationSharedData) {
			if (applicationSharedData.length) {
				applicationSharedData.map(applicationSD => {
					if (applicationSD.PostUrl[0] == '/')
						applicationSD.PostUrl = applicationSD.PostUrl.substring(1);

					if (applicationSD.PutUrl[0] == '/')
						applicationSD.PutUrl = applicationSD.PutUrl.substring(1);

					if (applicationSD.DeleteUrl[0] == '/')
						applicationSD.DeleteUrl = applicationSD.DeleteUrl.substring(1);

					applicationSD.ApplicationId = vm.applicationData.Id
				});
			}

			return applicationSharedData;
		}

		function getPermissionGroups() {
			return PermissionGroupService
				.getAll()
				.then(success => {
					vm.permissionGroups = success.Registers;
				}, error => {
					UtilHelper.errorCallback(error);
				})
		}

		function getModules() {
			return ModuleService
				.getAll()
				.then(success => {
					const modules = success.filter(x => x.ParentModuleId == null && x.IsFranchiser);
					vm.modules = $filter('orderBy')(modules, 'Title', false);
				}, error => {
					LoadingHelper.stopLoading('.loading-holder');
					UtilHelper.errorCallback(error);
				})
		}

		function init() {
			vm.getAll = null;
			vm.selectOptions = [{
				Value: true,
				Description: 'SIM'
			}, {
				Value: false,
				Description: 'NÃO'
			}];

			vm.applicationData = {};
			vm.applicationSharedData = null;
			vm.selectedTab = 1;

			vm.selectedPermissionGroups = [];
			vm.selectAllPermissionGroups = false;

			vm.imageMain = {
				display: ''
			};

			vm.flowOptionsMain = {
				query: () => {
					return {
						Path: `application/${vm.applicationData.Id}`,
						OldImage: vm.oldFormImageMain,
						CreateThumb: false,
						CreateThumbAdmin: false,
						MaxSize: 2000000
					}
				}
			};

			angular.extend(vm.flowOptionsMain, FlowConfigurationHelper.getFlowOptionsDefaults());

			LoadingHelper.startLoading('.loading-holder');

			$q.all([getModules(), getPermissionGroups()])
				.then(() => {
					getApplication();
				});
		}
	}
}());